<template>
    <div class="container mescroll-touch">
        <img src="../../assets/images/tuiguangtop.png" class="img" />
        <!-- <img src="../../assets/images/zuzhititle1.png" class="zuzhititleimg" /> -->
        <!-- <img src="../../assets/images/topguanggao.png" class="guanggaoimg" /> -->
        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">专家顾问团</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name nameleft">
                    廖万清
                    <div class="hos">海军军医大学第二附属医院</div>
                </div>
                <div class="name">
                    高兴华
                    <div class="hos">中国医科大学附属第一医院</div>
                </div>
                <div class="name nameleft">
                    张建中
                    <div class="hos">北京大学人民医院</div>
                </div>
                <div class="name">
                    张福仁
                    <div class="hos">山东第一医科大学附属皮肤病医院</div>
                </div>
                <div class="name nameleft">
                    陈&emsp;翔
                    <div class="hos">中南大学湘雅医院</div>
                </div>
                <div class="name">
                    王&emsp;刚
                    <div class="hos">空军腘锤军医大学西京医院</div>
                </div>
                <div class="name nameleft">
                    郑志忠
                    <div class="hos">复旦大学附属华山医院</div>
                </div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">主任委员</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name1">吴文育<span class="hosrow">复旦大学附属华山医院</span></div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">副主任委员</div>
                </div>
                <div class="tip">按姓氏拼音排序</div>
            </div>
            <div class="neirong">
                <div class="name nameleft">
                    陈爱军
                    <div class="hos">重庆医科大学附属第一医院</div>
                </div>
                <div class="name">
                    耿松梅
                    <div class="hos">西安交通大学第二附属医院</div>
                </div>
                <div class="name nameleft">
                    李福伦
                    <div class="hos">上海中医药大学附属岳阳中西医医院</div>
                </div>
                <div class="name ">
                    刘&emsp;红
                    <div class="hos">山东第一医科大学附属皮肤病医院</div>
                </div>
                <div class="name nameleft">
                    满孝勇
                    <div class="hos">浙江大学医学院附属第二医院</div>
                </div>
                <div class="name ">
                    潘&emsp;萌
                    <div class="hos">上海交通大学附属瑞金医院</div>
                </div>
                <div class="name nameleft">
                    陶&emsp;娟
                    <div class="hos">华中科技大学同济医学院附属协和医院</div>
                </div>
                <div class="name ">
                    杨&emsp;勇
                    <div class="hos">中国医学科学院皮肤病医院</div>
                </div>
                <div class="name nameleft">
                    赵作涛
                    <div class="hos">天津中医药研究院附属医院</div>
                </div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">大会发言人</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name1">樊一斌<span class="hosrow">浙江省人民医院</span></div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">大会秘书长</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name nameleft">
                    杜&emsp;娟
                    <div class="hos">复旦大学附属华山医院</div>
                </div>
                <div class="name">
                    张&emsp;岷
                    <div class="hos">上海爱宜生物科技有限公司</div>
                </div>
            </div>
        </div>

        <div class="model1">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zuzhiicon.png" class="modeltitleimg" />
                    <div class="modeltitletext">常务委员</div>
                </div>
                <div class="tip">按姓氏拼音排序</div>
            </div>
            <div class="neirong">
                <div class="name nameleft">
                    柏冰雪
                    <div class="hos">哈尔滨医科大学附属第二医院</div>
                </div>
                <div class="name">
                    齐&emsp;庆
                    <div class="hos">广州医科大学附属第二医院</div>
                </div>
                <div class="name nameleft">
                    卜璋于
                    <div class="hos">杭州市第一人民医院</div>
                </div>
                <div class="name">
                    乔建军
                    <div class="hos">浙江大学医学院附属第一医院</div>
                </div>
                <div class="name nameleft">
                    蔡&emsp;涛
                    <div class="hos">重庆医科大学附属第一医院</div>
                </div>
                <div class="name">
                    宋秀祖
                    <div class="hos">杭州市第三人民医院</div>
                </div>
                <div class="name nameleft">
                    曹&emsp;华
                    <div class="hos">上海交通大学附属瑞金医院</div>
                </div>
                <div class="name">
                    宋志强
                    <div class="hos">陆军军医大学第一附属医院</div>
                </div>
                <div class="name nameleft">
                    常&emsp;江
                    <div class="hos">优麦医生(上海麦色信息科技有限公司)</div>
                </div>
                <div class="name">
                    粟&emsp;娟
                    <div class="hos">中南大学湘雅医院</div>
                </div>
                <div class="name nameleft">
                    陈菊萍
                    <div class="hos">扬州市第一人民医院</div>
                </div>
                <div class="name">
                    孙&emsp;澜
                    <div class="hos">苏州市立医院</div>
                </div>
                <div class="name nameleft">
                    陈柳青
                    <div class="hos">武汉市中西医结合医院</div>
                </div>
                <div class="name">
                    孙勇虎
                    <div class="hos">山东第一医科大学附属皮肤病医院</div>
                </div>
                <div class="name nameleft">
                    陈晓栋
                    <div class="hos">南通大学附属医院</div>
                </div>
                <div class="name">
                    陶茂灿
                    <div class="hos">浙江省中医院</div>
                </div>
                <div class="name nameleft">
                    党宁宁
                    <div class="hos">山东省立医院</div>
                </div>
                <div class="name">
                    汪&emsp;旸
                    <div class="hos">北京大学第一医院</div>
                </div>
                <div class="name nameleft">
                    邓&emsp;辉
                    <div class="hos">上海市第六人民医院</div>
                </div>
                <div class="name">
                    汪&emsp;宇
                    <div class="hos">贵州医科大学附属医院</div>
                </div>
                <div class="name nameleft">
                    邓智利
                    <div class="hos">中南大学湘雅医院</div>
                </div>
                <div class="name">
                    王&emsp;芳
                    <div class="hos">中山大学附属第一医院</div>
                </div>
                <div class="name nameleft">
                    董达科
                    <div class="hos">江南大学附属医院</div>
                </div>
                <div class="name">
                    王惠平
                    <div class="hos">天津医科大学总医院</div>
                </div>
                <div class="name nameleft">
                    段彦娟
                    <div class="hos">上海市第七人民医院</div>
                </div>
                <div class="name">
                    王再兴
                    <div class="hos">安徽医科大学第一附属医院</div>
                </div>
                <div class="name nameleft">
                    傅&emsp;强
                    <div class="hos">青海红十字医院</div>
                </div>
                <div class="name">
                    魏爱华
                    <div class="hos">首都医科大学附属北京同仁医院</div>
                </div>
                <div class="name nameleft">
                    高&emsp;琳
                    <div class="hos">西安市红会医院</div>
                </div>
                <div class="name">
                    吴海竞
                    <div class="hos">中南大学湘雅二院</div>
                </div>
                <div class="name nameleft">
                    葛新红
                    <div class="hos">宁夏医科大学总医院</div>
                </div>
                <div class="name">
                    伍洲炜
                    <div class="hos">上海市第一人民医院</div>
                </div>
                <div class="name nameleft">
                    顾&emsp;煜
                    <div class="hos">新疆阿克苏第一人民医院</div>
                </div>
                <div class="name">
                    项蕾红
                    <div class="hos">复旦大学附属华山医院</div>
                </div>
                <div class="name nameleft">
                    郝&emsp;飞
                    <div class="hos">重庆医科大学附属第三医院</div>
                </div>
                <div class="name">
                    徐&emsp;楠
                    <div class="hos">上海市东方医院</div>
                </div>
                <div class="name nameleft">
                    黄&emsp;欣
                    <div class="hos">上海市同济医院</div>
                </div>
                <div class="name">
                    徐学刚
                    <div class="hos">中国医科大学附属第一医院</div>
                </div>
                <div class="name nameleft">
                    纪&emsp;超
                    <div class="hos">福建医科大学附属第一医院</div>
                </div>
                <div class="name">
                    许素玲
                    <div class="hos">宁波大学附属第一医院</div>
                </div>
                <div class="name nameleft">
                    季&emsp;江
                    <div class="hos">苏州大学附属第二医院</div>
                </div>
                <div class="name">
                    杨&emsp;骥
                    <div class="hos">复旦大学附属中山医院</div>
                </div>
                <div class="name nameleft">
                    金春琳
                    <div class="hos">沈阳市第七人民医院</div>
                </div>
                <div class="name">
                    杨镓宁
                    <div class="hos">四川省医学科学院·四川省人民医院</div>
                </div>
                <div class="name nameleft">
                    鞠&emsp;强
                    <div class="hos">上海仁济医院</div>
                </div>
                <div class="name">
                    尹光文
                    <div class="hos">郑州大学第一附属医院</div>
                </div>
                <div class="name nameleft">
                    雷明星
                    <div class="hos">重庆大学生物工程学院</div>
                </div>
                <div class="name">
                    尹志强
                    <div class="hos">江苏省人民医院</div>
                </div>
                <div class="name nameleft">
                    李建伟
                    <div class="hos">河南中医药大学第一附属医院</div>
                </div>
                <div class="name">
                    于&emsp;桉
                    <div class="hos">三生蔓迪</div>
                </div>
                <div class="name nameleft">
                    李&emsp;明
                    <div class="hos">复旦大学附属儿科医院</div>
                </div>
                <div class="name">
                    于&emsp;波
                    <div class="hos">北京大学深圳医院</div>
                </div>
                <div class="name nameleft">
                    李&emsp;魏
                    <div class="hos">复旦大学附属华山医院</div>
                </div>
                <div class="name">
                    喻&emsp;楠
                    <div class="hos">宁夏医科大学总医院</div>
                </div>
                <div class="name nameleft">
                    李艳玲
                    <div class="hos">河北医科大学第二医院</div>
                </div>
                <div class="name">
                    张&emsp;兵
                    <div class="hos">西湖大学</div>
                </div>
                <div class="name nameleft">
                    李玉叶
                    <div class="hos">昆明医科大学附属第一医院</div>
                </div>
                <div class="name">
                    张成锋
                    <div class="hos">复旦大学附属华山医院</div>
                </div>
                <div class="name nameleft">
                    李智铭
                    <div class="hos">温州医科大学第一附属医院</div>
                </div>
                <div class="name">
                    张春红
                    <div class="hos">山东大学第二医院</div>
                </div>
                <div class="name nameleft">
                    梁云生
                    <div class="hos">南方医科大学皮肤病医院</div>
                </div>
                <div class="name">
                    张国强
                    <div class="hos">河北医科大学第一医院</div>
                </div>
                <div class="name nameleft">
                    林尽染
                    <div class="hos">复旦大学附属华山医院</div>
                </div>
                <div class="name">
                    张慧萍
                    <div class="hos">湖南省妇幼保健医院</div>
                </div>
                <div class="name nameleft">
                    刘&emsp;晓
                    <div class="hos">吉林市中心医院</div>
                </div>
                <div class="name">
                    张&emsp;敏
                    <div class="hos">内蒙古包钢医院</div>
                </div>
                <div class="name nameleft">
                    刘业强
                    <div class="hos">上海市皮肤病医院</div>
                </div>
                <div class="name">
                    张&emsp;勇
                    <div class="hos">武汉同济医院</div>
                </div>
                <div class="name nameleft">
                    卢&emsp;忠
                    <div class="hos">复旦大学附属华山医院</div>
                </div>
                <div class="name">
                    赵恒光
                    <div class="hos">重庆医科大学附属第二医院</div>
                </div>
                <div class="name nameleft">
                    鲁&emsp;严
                    <div class="hos">江苏省人民医院</div>
                </div>
                <div class="name">
                    郑&emsp;跃
                    <div class="hos">南方医科大学南方医院</div>
                </div>
                <div class="name nameleft">
                    罗晓燕
                    <div class="hos">重庆医科大学附属儿童医院</div>
                </div>
                <div class="name">
                    周&emsp;城
                    <div class="hos">北京大学人民医院</div>
                </div>
                <div class="name nameleft">
                    骆肖群
                    <div class="hos">复旦大学附属华山医院</div>
                </div>
                <div class="name">
                    周乃慧
                    <div class="hos">苏州大学第一附属医院</div>
                </div>
                <div class="name nameleft">
                    吕成志
                    <div class="hos">大连市皮肤病医院</div>
                </div>
                <div class="name">
                    周&emsp;强
                    <div class="hos">浙江大学附属医院邵逸夫医院</div>
                </div>
                <div class="name nameleft">
                    马&emsp;岚
                    <div class="hos">欧莱雅(中国)有限公司</div>
                </div>
                <div class="name">
                    周&emsp;汛
                    <div class="hos">重庆中医院</div>
                </div>
                <div class="name nameleft">
                    马伟元
                    <div class="hos">潍坊医学院附属医院</div>
                </div>
                <div class="name">
                    朱军容
                    <div class="hos">湖北省中医院</div>
                </div>
                <div class="name nameleft">
                    马彦云
                    <div class="hos">复旦大学工程与应用技术研究院</div>
                </div>
                <div class="name">
                    朱&emsp;敏
                    <div class="hos">复旦大学附属华山医院</div>
                </div>
                <div class="name nameleft">
                    潘炜华
                    <div class="hos">海军军医大学第二附属医院</div>
                </div>
                <div class="name">
                    左先波
                    <div class="hos">中日友好医院</div>
                </div>
                <div class="name nameleft">
                    皮龙泉
                    <div class="hos">延边大学附属医院</div>
                </div>
            </div>
        </div>

        <div class="submit" @click="submit">点击申请加入</div>
        <div style="height: .2rem;"></div>
        <!-- <div class="footer">
            按姓氏拼音排序
        </div> -->
        <!-- <floatback /> -->
    </div>
</template>

<script>
// import floatback from './floatback.vue';
import mixin from '../../common/mixin/mixins'
export default {
    name: 'zuzhi',
    data() {
        return {
        }
    },
    mixins: [mixin],
    components: {
        // floatback
    },
    created() {
        this.initacmedShare();
        document.title = "加入ACMED";
    },
    methods: {
        submit() {
            this.$router.push({ path: "/newrenzheng" });
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    // background: rgb(228, 236, 255);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.zuzhititleimg {
    display: block;
    width: 55%;
    margin: auto;
    margin-bottom: .2rem
}

.zuzhititleimg1 {
    display: block;
    width: 55%;
    margin: .5rem auto .2rem auto;
}

.guanggaoimg {
    display: block;
    width: 92%;
    margin: 0.5rem auto;
}

.modelline {
    border-bottom: 0.026667rem solid #003585;
    border-bottom-left-radius: 50rem;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
}

.modeltitle {
    background: rgb(0, 53, 133);
    width: 37%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitleimg {
    display: block;
    width: 15%;
    background: #fff;
    border-radius: 50rem;
    width: 0.5rem;
    height: 0.5rem;
    box-sizing: border-box;
    padding: 0.05rem;
}

.modeltitletext {
    margin-left: 0.2rem;
    color: #fff;
    font-weight: bold;
    // font-size: 16px;
}

.model {
    width: 98%;
    margin: auto;
    margin-top: 0.5rem;
}

.model1 {
    width: 98%;
    margin: auto;
    margin-top: 0.5rem;
    padding-bottom: .3rem;
    margin-bottom: 1.5rem;
}

.center {
    text-align: center;
}

.preple {
    color: rgb(0, 53, 133);
}

.neirong {
    margin-top: .3rem
}

.ziti {
    font-size: .37rem;
}

.neirong {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.name {
    width: 50%;
    text-align: left;
    font-size: .35rem;
    box-sizing: border-box;
    padding: 0.1rem 0.3rem;
}

.name1 {
    width: 100%;
    text-align: left;
    font-size: .35rem;
    box-sizing: border-box;
    padding: 0.1rem 0.3rem;
}

.footer {
    width: 92%;
    margin: auto;
    margin-bottom: 0.5rem;
    text-align: right;
    font-size: .3rem;
    border-bottom: 0.5rem solid rgb(0, 53, 133);
    font-weight: bold;
}

.hos {
    font-size: .25rem;
}

.hosrow {
    margin-left: .25rem;
    font-size: .25rem;
}

.nameleft {
    border-right: 1px solid #003585;
}

.tip {
    font-size: .3rem;
    margin-left: 0.1rem;
    margin-bottom: 0.05rem;
}

.submit {
    width: 80%;
    margin: auto;
    height: 35px;
    line-height: 35px;
    border-radius: 35px;
    background-color: red;
    // background: linear-gradient(to right, red, #ED7B7D);
    // background: linear-gradient(to right, #004899, #009eec);
    color: #ffffff;
    text-align: center;
    margin-bottom: 20px;
    margin-top: 0.2rem;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}
</style>